<template>
    <div>
        <clocklogs-report />
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Timelogs</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-4-tablet is-2-desktop is-2-widescreen">
                <o-field>
                    <o-autocomplete
                        v-model="filters.project"
                        placeholder="Project"
                        :keep-first="true"
                        :data="projects"
                        field="name"
                        icon="search"
                        @change.native="fetchPaginatedData()"
                        @keydown.native.enter="fetchPaginatedData()"
                        max-results="1000"
                    ></o-autocomplete>
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop is-2-widescreen">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.activity"
                        placeholder="Activity"
                        icon="search"
                        @change.native="fetchPaginatedData()"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop is-2-widescreen">
                <o-field>
                    <o-autocomplete
                        v-model="filters.user"
                        placeholder="User"
                        :keep-first="true"
                        :data="allUsers"
                        field="full_name"
                        icon="search"
                        @change.native="fetchPaginatedData()"
                        @keydown.native.enter="fetchPaginatedData()"
                        max-results="1000"
                    ></o-autocomplete>
                </o-field>
            </div>
            <div class="column is-4 is-2-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <a @click.prevent="openTimeLogModal(null)" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns toolbar-box action-right">
            <div class="column is-4-tablet is-2-desktop is-offset-3">
                <o-field class="is-marginless">
                    <o-select placeholder="Focus type" v-model="filters.activity_type" :expanded="true">
                        <option :value="undefined">All</option>
                        <option value="task">Task</option>
                        <option value="project-service">Service</option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <o-input
                            v-model="filters.title"
                            placeholder="Focus"
                            icon="search"
                            type="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
        </div>
        <div class="columns toolbar-box action-right">
            <div class="column is-4-tablet is-2-desktop is-offset-3">
                <div class="field">
                    <datepicker v-model="filters.from"
                                input-class="input is-fullwidth"
                                placeholder="From" :absolute="true"
                    />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <datepicker v-model="filters.to"
                            input-class="input is-fullwidth"
                            placeholder="To" :absolute="true"
                />
            </div>
        </div>
        <o-table
            class="fullwidth-table is-responsive is-responsive-desktop"

            v-if="isTableVisible"
            :data="paginatedData"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"
            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                        v-for="col in tableColumns"
                        #default="{ row }"
                        :field="col.field"
                        :label="col.field === 'actions' ? '' : col.label"
                        :sortable="col.sortable"
                    >
                        <router-link v-if="col.field === 'user_id'" :to="{ name: 'users.show', params: { slug: row.user_id } }">
                            {{  $filters.valueOrDefault(userNameById(row.user_id), '–') }}
                        </router-link>
                        <router-link v-if="col.field === 'project_id'" :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                            {{  $filters.valueOrDefault(projectNameById(row.project_id), '–') }}
                        </router-link>

                        <span v-if="col.field === 'client'">{{ $filters.valueOrDefault(row.company_name,'-') }}</span>
                        <span v-if="col.field === 'focus'">{{ $filters.valueOrDefault(timelogActivityName(row)) }}</span>
                        <span v-if="col.field === 'date'">{{  $filters.valueOrDefault($filters.date(row.date)) }}</span>
                        <span v-if="col.field === 'time'">{{ row.time }}</span>
                        <span v-if="col.field === 'note'" v-html="row.note"></span>
                        <span v-if="col.field === 'activity_type'">{{ row.activity_type }}</span>
                        <span v-if="col.field === 'activity'">{{  $filters.valueOrDefault(dictionaryEntryNameByTypeAndId('timelog-activity', row.activity_name)) }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>
                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template #trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link><a @click="openTimeLogModal(row)">View</a></o-dropdown-item>
                        </o-dropdown>
                        <span v-if="col.field === 'hourly_rate'">{{ $filters.currency(row.hourly_rate ) }}</span>
                        <span v-if="col.field === 'cost'">{{ $filters.currency(row.cost ) }}</span>
                        <span v-if="col.field === 'last_editor_id'">{{ userNameById(row.last_editor_id) }}</span>
                    </o-table-column>
                </template>
            </template>
            <template #footer>
                <th v-if="table.checkable"/>
                <template v-for="(col, idx) in tableColumns">
                    <th v-if="col.field === 'time'" label="Total time" :key="idx">
                        {{ $filters.valueOrDefault(totalTime) }}
                    </th>
                    <th v-else-if="idx === 0">Totals</th>
                </template>
            </template>
          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <div>Total: <strong>{{ total }}</strong></div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTimeLogModalActive" has-modal-card>
            <time-log-modal :timelog-prop="timelog" @timelog-created="fetchPaginatedData"/>
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import Table from './../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'
    import ClocklogsReport from './ClocklogsReport'
    import Datepicker from '../../components/Datepicker.vue'

    export default {
        components: {
            ClocklogsReport,
            Datepicker,
        },

        mixins: [Table],

        mounted () {
            this.fetchPaginatedData(true)
        },

        data () {
            return {
                tableName: 'timelogs-index',
                timelog: null,
                isTimeLogModalActive: false,
                filters: {
                    activity: '',
                    activity_id: null,
                    activity_type: null,
                    from: null,
                    project: '',
                    to: null,
                    user: ''
                },
                // table: {
                //     defaultSort: ['date', 'desc'],
                // },
            }
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchTimelogs',
                removeItem: 'removeTimelog'
            }),

            openTimeLogModal(timelog) {
                this.timelog = timelog
                this.isTimeLogModalActive = true
            },
            resetFilters() {
                for (let field in this.visibleFilters) {
                    this.filters[field] = _.isArray(this.filters[field]) ? [] : ''
                }
                this.filters.activity = null
                this.filters.activity_type = null
                if(this.table.paginated) {
                    this.fetchPaginatedData(true, this.requestParams)
                }
            },
        },

        computed: {
            ...mapGetters([
                'projects',
                'allUsers',
                'userNameById',
                'projectNameById',
                'timelogActivityName',
                'dictionaryEntryNameByTypeAndId',
            ]),

            ...mapGetters({
                activityById: 'activityById',
                itemsByIds: 'timelogsByIds',
                projectById: 'projectById',
                timelogActivityName: 'timelogActivityName',
            }),
            totalTime() {
                let totalTime = 0
                this.paginatedData.forEach(i => {
                    totalTime += isNaN(i.time) || i.time == null ? 0 : parseFloat(i.time)
                })
                totalTime = Number(totalTime).toFixed(2)
                return totalTime
            },
        },
        watch: {
            filters: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                }
            },
        },
    }
</script>
